import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Position } from '../../../models/position';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { findPositionAct, savePositionAct, updatePositionAct } from '../../../store/position/position.actions';
import { distinctUntilChanged, map } from 'rxjs';

@Component({
  selector: 'app-positions-detail',
  standalone: false,
  templateUrl: './positions-detail.component.html',
  styleUrl: './positions-detail.component.css'
})
export class PositionsDetailComponent {

  positionForm!: NgForm;
  loading = true;
  //title!: string;
  position: Position = new Position();
  violations: any;

  constructor(
    private route: ActivatedRoute,
    private positionStore: Store<{positionRdc: any}>
  ) {

    this.positionStore.pipe(
      select('positionRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        position: state.position,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ position, violations, loading }) => {
      this.position = JSON.parse(JSON.stringify(position));
      this.violations = violations;
      this.loading = loading;
      //this.title = 'Detalles de Posición';
    });
  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.positionStore.dispatch(findPositionAct({ id }));
      }else{
        this.position = new Position();
        this.position.active = true;
        this.loading = false;
        //this.title = 'Agregar posición';
      }
    });

  }

  onSubmitPosition(positionForm: NgForm): void {
    this.loading = true;
    this.positionForm = positionForm;
    const positionCopy = JSON.parse(JSON.stringify(this.position));
   
    if (positionCopy.id > 0) {
      this.positionStore.dispatch(updatePositionAct({ positionUpdated: positionCopy }))
    } else {
      this.positionStore.dispatch(savePositionAct({ positionNew: positionCopy }))
    }
  }

}
